class TokenUtilty {
  static decodeToken(dateString) {
    if (!dateString) {
      return '';
    }
    const payloadBase64 = dateString.split('.')[1];
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);
    payload.exp = new Date(payload.exp);
    return payload;
  }
}

export default TokenUtilty;
